import axiosApi from "axios";
import {
  HandleAxiosError,
  HandleAxiosResponse,
} from "@/configs/axios/AxiosHandlers";
import { AxiosApi, BaseUrl } from "@/configs/axios/Axios";
import {
  LocaleTransformRequest,
  TokenTransformRequest,
} from "@/configs/axios/AxiosTransforms";

/**
 * @param {string} url
 * @return {string}
 */
export function GetApiV1Url(url = "") {
  return [
    AxiosApi(1),
    url
      .split("/")
      .filter((path) => !!path)
      .join("/"),
  ].join("/");
}

const ApiV1 = axiosApi.create({
  baseURL: [BaseUrl(), AxiosApi(1)].join("/"),
  headers: {
    Accept: "Application/json",
  },
  transformRequest: [
    TokenTransformRequest,
    LocaleTransformRequest,
    ...axiosApi.defaults.transformRequest,
  ],
});

export default ApiV1;

ApiV1.interceptors.response.use(HandleAxiosResponse, HandleAxiosError);
